// Simple authentication service using localStorage
// In production, this should use JWT tokens and a real backend authentication system
class AuthService {
    constructor() {
        this.STORAGE_KEY = 'logistic_admin_auth';
        // Credentials are injected at build time from LOGISTIC/.env (ADMIN_USERNAME / ADMIN_PASSWORD)
        this.DEFAULT_CREDENTIALS = {
            username: process.env.ADMIN_USERNAME || 'admin',
            password: process.env.ADMIN_PASSWORD || '',
        };
    }
    login(username, password) {
        // In production, this should make an API call to backend
        if (!this.DEFAULT_CREDENTIALS.password)
            return false;
        if (username === this.DEFAULT_CREDENTIALS.username &&
            password === this.DEFAULT_CREDENTIALS.password) {
            const user = {
                username,
                role: 'admin',
            };
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify(user));
            return true;
        }
        return false;
    }
    logout() {
        localStorage.removeItem(this.STORAGE_KEY);
    }
    isAuthenticated() {
        const userStr = localStorage.getItem(this.STORAGE_KEY);
        if (!userStr)
            return false;
        try {
            const user = JSON.parse(userStr);
            return !!user && user.role === 'admin';
        }
        catch {
            return false;
        }
    }
    getCurrentUser() {
        const userStr = localStorage.getItem(this.STORAGE_KEY);
        if (!userStr)
            return null;
        try {
            return JSON.parse(userStr);
        }
        catch {
            return null;
        }
    }
}
export const authService = new AuthService();
export default authService;
